import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {actions, select} from './connectors';
import {
  EXTENDED_NOTE_LENGTH,
  NOTE_AUTO_TOGGLE_DURATION
} from '~/constants/ProductConstants';
import {InfoCircleIcon, Typography, XCloseIcon} from '@customink/pigment-react';

import './index.scss';

export const SLEEVE_PRINT_DIFF_IMAGERY_MSG =
  "The product shown here is different than the one you've selected, but is a good representation of what your sleeve design will look like.";

export function sleevePrintDiffImageryMsg() {
  return (
    <div>
      <span>{SLEEVE_PRINT_DIFF_IMAGERY_MSG}</span>
    </div>
  );
}

export function shouldSyncShowProductNoteOnUpdate({prevProps, props, state}) {
  if (!prevProps || !props || !state) return false;
  return (
    prevProps.showProductNote !== props.showProductNote &&
    props.showProductNote !== state.visible
  );
}

export class ProductNote extends Component {
  static propTypes = {
    handleProductNoteClose: PropTypes.func,
    hasInvalidProductImage: PropTypes.func,
    iconSelected: PropTypes.bool,
    isAnchorDebossed: PropTypes.bool,
    isAnchorEmbossed: PropTypes.bool,
    isAnchorLaserEngraved: PropTypes.bool,
    isSelectedProductEmbroidered: PropTypes.bool,
    note: PropTypes.string,
    productId: PropTypes.string,
    showProductNote: PropTypes.bool,
    showSleevePrintRepImageryNote: PropTypes.bool,
    sleevePrintPriceInfo: PropTypes.func,
    onToggleNote: PropTypes.func
  };

  static defaultProps = {
    showProductNote: true,
    handleProductNoteClose: () => {},
    onToggleNote: () => {}
  };

  state = {
    visible: true
  };

  componentDidMount() {
    this.setState({visible: this.props.showProductNote});
  }

  UNSAFE_componentWillReceiveProps({productId}) {
    const productChanged =
      this.props.productId && productId !== this.props.productId;

    if (productChanged && !this.state.visible) {
      this.setCloseDelay();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      shouldSyncShowProductNoteOnUpdate({
        prevProps,
        props: this.props,
        state: this.state
      })
    ) {
      this.setState({visible: this.props.showProductNote});
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleOnClick = () => {
    if (!this.state.visible) {
      this.props.onToggleNote();
    } else {
      this.props.sleevePrintPriceInfo('ndx/sleeve/priceinfo/minimize');
      this.props.handleProductNoteClose();
    }
    this.toggleVisible();
  };

  toggleVisible = () => {
    clearTimeout(this.timeout);

    this.setState(previousState => {
      return {
        visible: !previousState.visible
      };
    });
  };

  setCloseDelay() {
    this.toggleVisible();
    this.timeout = setTimeout(() => {
      this.toggleVisible();
    }, NOTE_AUTO_TOGGLE_DURATION);
  }

  renderExtendedNote() {
    const {visible} = this.state;
    const displayNote = this.getNote();

    const wrapperClasses = classnames('ndx-ProductNote-noteWrapper', {
      'is-expanded': !!displayNote && visible
    });

    return (
      <div className={wrapperClasses}>
        <Typography
          variant="uiTextSmall"
          className="ndx-ProductNote-noteWrapper-note">
          {displayNote}
        </Typography>
      </div>
    );
  }

  getNote() {
    const {note, showSleevePrintRepImageryNote, hasInvalidProductImage} =
      this.props;

    if ((!note && showSleevePrintRepImageryNote) || hasInvalidProductImage) {
      return sleevePrintDiffImageryMsg();
    }
    return note;
  }

  renderClickIcon() {
    const {visible} = this.state;
    const interactionIcon = visible ? <XCloseIcon /> : <InfoCircleIcon />;
    const iconClasses = classnames('ndx-ProductNote-icon', {
      'ndx-ProductNote-icon--close': visible
    });

    return (
      <div className={iconClasses} onClick={this.handleOnClick}>
        {interactionIcon}
        {!this.state.visible && (
          <Typography
            variant="uiTextTiny"
            className="ndx-ProductNote-icon-text">
            Info
          </Typography>
        )}
      </div>
    );
  }

  render() {
    const {note, iconSelected, showSleevePrintRepImageryNote} = this.props;
    const showNote = !!note;

    const noteClasses = classnames('ndx-ProductNote', {
      'ndx-ProductNote--hidden':
        !showSleevePrintRepImageryNote && (!showNote || iconSelected),
      'is-expanded': this.state.visible,
      'ndx-ProductNote--extended':
        (showNote && note?.length > EXTENDED_NOTE_LENGTH) ||
        showSleevePrintRepImageryNote
    });

    return (
      <div className={noteClasses}>
        {this.renderExtendedNote()}
        {this.renderClickIcon()}
      </div>
    );
  }
}

export default connect(select(), dispatch => actions(dispatch))(ProductNote);
